import { render, staticRenderFns } from "./cwhtgl.vue?vue&type=template&id=71298daf&scoped=true&"
import script from "./cwhtgl.vue?vue&type=script&lang=js&"
export * from "./cwhtgl.vue?vue&type=script&lang=js&"
import style0 from "./cwhtgl.vue?vue&type=style&index=0&id=71298daf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71298daf",
  null
  
)

export default component.exports